/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChevronTripleDown = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M18.707 15.207 12 21.914l-6.707-6.707 1.414-1.414L12 19.086l5.293-5.293zm0-6L12 15.914 5.293 9.207l1.414-1.414L12 13.086l5.293-5.293zm0-6L12 9.914 5.293 3.207l1.414-1.414L12 7.086l5.293-5.293z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChevronTripleDown as ChevronTripleDown };
